
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { DiscountFormValues } from "@/types/discount";

interface DiscountTypeSelectProps {
  form: UseFormReturn<DiscountFormValues>;
}

export const DiscountTypeSelect = ({ form }: DiscountTypeSelectProps) => {
  return (
    <FormField
      control={form.control}
      name="discount_type"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Discount Type</FormLabel>
          <Select onValueChange={field.onChange} value={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select discount type" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="fixed">Fixed Amount</SelectItem>
              <SelectItem value="percentage">Percentage</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
